/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { Image, DateValue, useModal } from '@jutro/components';
import { ErrorLevel } from '@xengage/gw-portals-edge-validation-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLRatingFactorComponent, RenameQuoteModalPopup, RenameQuoteModalPopupStyles } from 'ml-capability-quoteandbind-common-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { MLPolicyTypeUtil, MLWizardDataSnapshotContext } from 'ml-portals-util-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLBundleService } from 'ml-services-common-react';
import {PolicyService, MLProducerEligibilityService, UserService} from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-account';
import { AccountService as AccountPolicyService } from 'gw-capability-gateway-policy';
import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages } from "gw-capability-gateway-quoteandbind-common-react";
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { Button, Accordion, AccordionCard, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import PATrackEvent from "../../../../capabilities-react/gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent";
import MLNavigationStepsComponent from "./MLNavigationSteps/MLNavigationStepsComponent";
import atv from 'ml-digital-theme-styles/images/farmers/icons/atv.svg';
import boat from 'ml-digital-theme-styles/images/farmers/icons/boat.svg';
import golfcart from 'ml-digital-theme-styles/images/farmers/icons/golf-cart.svg';
import motorcycle from 'ml-digital-theme-styles/images/farmers/icons/motorcycle.svg';
import motorhome from 'ml-digital-theme-styles/images/farmers/icons/motorhome.svg';
import snowmobile from 'ml-digital-theme-styles/images/farmers/icons/snowmobile.svg';
import traveltrailer from 'ml-digital-theme-styles/images/farmers/icons/travel-trailer.svg';

import styles from './WizardSidebar.module.scss';
import messages from './WizardSidebar.messages';
import MlBundleWidget from './MlBundleWidget/MlBundleWidget';

import UpdateProducerCodePopup from './Popup/UpdateProducerCodePopup.metadata.json5';
import NoteDetailsPopup from './Popup/NoteDetailsPopup.metadata.json5';
import NoteDetailsPopupMessages from './Popup/NoteDetailsPopup.messages';


import { IntlContext } from '@jutro/legacy/locale';


const STATUS_COMPLETE = 'complete';
const STATUS_ACTIVE = 'active';
const STATUS_PENDING = 'pending';

/**
 * @typedef {import('gw-portals-edge-validation-js/errors').GenericUIIssue} GenericUIIssue
 */

/**
 * Renders an icon for steps with errors
 * @param {Array<GenericUIIssue>} errorsAndWarnings array
 * @returns {Object}
 */
function renderErrors(errorsAndWarnings = []) {
    const highestLevel = errorsAndWarnings
        .map((err) => err.level)
        .reduce((currentHighest, currentError) => {
            if (!currentHighest) {
                return currentError;
            }
            if (currentHighest === ErrorLevel.LEVEL_WARN) {
                // currentError can only Greater or Equal than currentHighest
                return currentError;
            }
            return currentHighest;
        }, null);
    switch (highestLevel) {
        case ErrorLevel.LEVEL_ERROR:
            return <Icon icon="mi-remove_circle_outline" className={styles.errorIssue} />;
        case ErrorLevel.LEVEL_WARN:
            return <Icon icon="mi-warning" className={styles.warningIssue} />;
        default:
            return null;
    }
}

function jumpRenderModal(jumpTo, steps, step, wizardContext, customMessageModal, wizardDataWithSnapshotFlag) {
    const modalMessages = {
        title: !_.isEmpty(customMessageModal)
            ? customMessageModal.title
            : commonMessages.wantToJump,
        message: !_.isEmpty(customMessageModal)
            ? customMessageModal.message
            : commonMessages.wantToJumpMessage,
        messageProps: {
            ok: commonMessages.yes,
            close: commonMessages.close
        }
    };
    const { wizardData, wizardSnapshot, onPageJump } = wizardContext;

    const index = _.findIndex(steps, ({id}) => id === step.id);

    let allowPageJump_Ext = true;
    if (wizardData.aspects && !(wizardData.aspects.subtreeValid && wizardData.aspects.valid)) {
        if (wizardSnapshot?.aspects && wizardSnapshot?.aspects.subtreeValid && wizardSnapshot?.aspects.valid) {
            _.set(wizardData, 'value', _.cloneDeep(wizardSnapshot?.value));
            wizardDataWithSnapshotFlag.current = true;
        } else {
            allowPageJump_Ext = false;
        }
    }
    
    // Reset the Page Load Time when user is using the left wizard sidebar to navigate
    sessionStorage.removeItem('userSubmitAction');
    sessionStorage.removeItem('userSubmitted');
    
    if (allowPageJump_Ext) {
        onPageJump({
            wizardData,
            wizardSnapshot,
            modalMessages,
            index
        });
    }
}

function getLobIconClassName(productCode) {
    switch (productCode) {
        case 'PersonalAuto': {
            return 'icon-icon-car-white';
        }
        case 'PersonalUmbrella': {
            return 'icon-foremost-umbrella-icon';
        }
        case 'HOPHomeowners': {
            return 'icon-ml-home-detailed-icon';
        }
        default: {
            break;
        }
    }
}

const duplicatedStepToHide = (step, steps, index) => {
    const stepIndexes = steps.flatMap((s, loopIndex) => {
        if (s.path === step.path) {
            return loopIndex;
        };
        return [];
    });
    return stepIndexes.length > 1 && index !== _.max(stepIndexes);
};

function isOnQuoteDetailsStep(step) {
    return step.mlStepName === 'quoteDetails';
}

function WizardSidebar(props) {
    const modalApi = useModal();
    const { EndorsementService } = useDependencies('EndorsementService');
    const { runtimeEnv = '' } = appConfig;
    const prodEnvironmentUrl = runtimeEnv === 'local' ? '' : '/producer-engage'
    const confirmationPath = ["/producer-engage/quote-pa/success", "/producer-engage/quote-pup/success", "/producer-engage/quote-ho/success"]
    const isSuccessPolicy = confirmationPath.includes(window.location.pathname);

    function renderSteps(
        translator,
        steps,
        stepsWithErrors,
        jumpTo,
        wizardContext,
        customMessageModal,
        isPolicyChangeML,
        newWizardSteps,
        currentStep,
        isChangeTransaction,
        model,
        currentStepIndex,
        wizardDataWithSnapshotFlag
    ) {

        const cannotSelectSteps = (step) => {
            const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
            const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';

            const checkIfTransitionAllowedForPostQuote = () => {
                if (model.isBundle_ML) {
                    const isPostQuoteBundle = MLBundleService.isJobForPostQuote(model.quoteID);
                    const quoteDetailsStepIndex = _.findIndex(steps, ({mlStepName}) => mlStepName === 'quoteDetails');
                    return !(isPostQuoteBundle && (currentStepIndex < quoteDetailsStepIndex));
                }
                return true;
            };

            const checkIfTransitionAllowedForBookRoll = () => {
                return step.mlStepName === 'quoteDetails' || (model.bookrollInd_ML !== BOOKROLL_WITH_RATE_CAPPING && !model.rateCapped_Ext);
            };

            const checkIfTransitionAllowedWhenNotAK7DayPolicy = () => {
                return !(model.isPersonalAuto() && model.baseData && model.baseData.policyAddress.state === 'AK' && model.baseData.termType === '7Days');
            };

            const transitionAllowed = checkIfTransitionAllowedForPostQuote(step, model) && checkIfTransitionAllowedForBookRoll() && checkIfTransitionAllowedWhenNotAK7DayPolicy(model);
            return !transitionAllowed;
        };

        const getGroupedSteps = ((groupStep, index) => {
            const getAccordionHeader = () => {
                switch(groupStep.status) {
                    case STATUS_PENDING: {
                        return 'ml-count-icon large static light';
                    }
                    case STATUS_ACTIVE: {
                        return 'icon-ml-status-check-active';
                    }
                    case STATUS_COMPLETE: {
                        return 'icon-ml-status-check-complete';
                    }
                    default: {
                        return '';
                    }
                }
            }

            const getHeader = () => {
                return (
                    <li 
                        className={
                            classNames('ml-leftrail-nav__menu-item grouped', {
                                active: groupStep.status === STATUS_ACTIVE,
                                open: groupStep.isOpen
                            })
                        }
                        onClick={() => {groupStep.isOpen = !groupStep.isOpen}}
                    >
                        <span className={getAccordionHeader()}>
                            {groupStep.status === STATUS_PENDING &&
                            <span className="ml-grouped-step">{index + 1}</span> 
                            }
                        </span>
                        {groupStep.group}
                    </li>
                );
            }
            return (
                <Accordion
                    closeOthers
                    defaultOpenedId={groupStep.isOpen ? groupStep.group : ''}
                    showFrame={false}
                >
                    <AccordionCard
                        id={groupStep.group}
                        renderHeader={getHeader}
                        cardHeadingClassName={styles.cardHeader}
                    >
                        <li className="ml-leftrail-nav__menu-item expanded">
                            <ul className="ml-leftrail-nav__expanded-menu">
                                {
                                    groupStep.steps.map((step) => {
                                        return (
                                            <button 
                                                className={
                                                    classNames(
                                                        'ml-leftrail-nav__expanded-menu-item',
                                                        {
                                                            active: step.status === STATUS_ACTIVE,
                                                            pending: step.status === STATUS_PENDING
                                                        },
                                                        styles.cardHeading                                                    )
                                                }
                                                tabIndex={0}                              
                                                onClick={() => {
                                                    if (isChangeTransaction !== true && cannotSelectSteps(step)) {
                                                        return;
                                                    } 

                                                    if(isSuccessPolicy){
                                                        return;
                                                    }

                                                    jumpRenderModal(
                                                        jumpTo,
                                                        steps,
                                                        step,
                                                        wizardContext,
                                                        customMessageModal,
                                                        wizardDataWithSnapshotFlag
                                                    );
                                                }}    
                                                disabled={!step.visited}
                                            >
                                                <span 
                                                    className={classNames({
                                                        'icon-ml-status-check-complete': step.status === STATUS_COMPLETE,
                                                        'icon-ml-status-check-active': step.status !== STATUS_COMPLETE
                                                    })}
                                                />
                                                {translator(step.title)}
                                            </button>
                                        )
                                    })
                                }
                            </ul>
                        </li>
                    </AccordionCard>
                </Accordion>              
            )
        })

        const getGeneralSteps = (parentDivStyles, ungroupedStep, index, changeTransactionClassName) => {
            const step = ungroupedStep.step;
            return (
                <div className={parentDivStyles}>
                    <div className={classNames(styles.iconClass)}>
                        <li 
                            className={
                                classNames(changeTransactionClassName || 'ml-leftrail-nav__menu-item',
                                    {
                                        active: step.status === STATUS_ACTIVE
                                    })
                            }
                            key={step.id}
                            onClick={() =>
                            {
                                if (isChangeTransaction !== true && cannotSelectSteps(step)) {
                                    return;
                                }

                                if(isSuccessPolicy){
                                    return;
                                }
                                
                                jumpRenderModal(
                                    jumpTo,
                                    steps,
                                    step,
                                    wizardContext,
                                    customMessageModal,
                                    wizardDataWithSnapshotFlag
                                );
                            }}
                        >
                            { !changeTransactionClassName && <span 
                                className={
                                    classNames(
                                        {
                                            'ml-count-icon large static light': step.status === STATUS_PENDING,
                                            'icon-ml-status-check-complete': step.status === STATUS_COMPLETE,
                                            'icon-ml-status-check-active': step.status === STATUS_ACTIVE
                                        })
                                }
                            >
                                {
                                    step.status === STATUS_PENDING &&
                                    <span>{ index + 1 }</span>
                                }
                            </span>}
                            { changeTransactionClassName && <span
                                className={
                                    classNames(
                                        {
                                            'icon-ml-status-check-active': step.status !== STATUS_COMPLETE,
                                            'icon-ml-status-check-complete': step.status === STATUS_COMPLETE
                                        }
                                    )
                                }
                            /> }
                            {translator(step.title)}
                            {renderErrors(stepsWithErrors[step.id])}
                        </li>
                    </div>
                </div>
            )
        }

        const nonDuplicatedSteps = steps.filter((s, index) => !duplicatedStepToHide(s, steps, index));

        const getDisplayableIndex = (step, index) => {
            if (!isPolicyChangeML) {
                return index;
            }

            // PolChange - Get index of steps without duplicated placeholder steps. Index will be skewed otherwise
            return nonDuplicatedSteps.findIndex((s) => s.path === step.path);
        }

        if(!isChangeTransaction){
            const submissionStatus = _.get(model, 'baseData.status_ML');
            const isBindSubmission = !!_.get(model, 'bindData.policyNumber') && (submissionStatus === 'Bound' || submissionStatus === 'Binding');

            if (isBindSubmission && newWizardSteps.length < 2) {
                return <></>;
            }

            return newWizardSteps.map((step, index) => {

                const parentDivStyles = classNames({
                    [styles.hidden]: isPolicyChangeML && duplicatedStepToHide(step, steps, index)
                });
                return (
                    <div>
                        {(step.group !== '') ?
                            getGroupedSteps(step, index) :
                            <div>
                                {getGeneralSteps(parentDivStyles, step, index)}
                            </div>
                        }
                    </div>
                );
            });
        }
        return newWizardSteps.map((step, index) => {
            const parentDivStyles = classNames({
                [styles.hidden]: isPolicyChangeML && duplicatedStepToHide(step, steps, index)
            });
            return (
                getGeneralSteps(parentDivStyles, step, index, 'ml-leftrail-nav__expanded-menu-item')
            );
        });

    }

    const { authHeader } = useAuthentication();

    const { UserService } = useDependencies('UserService');
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [currentUser, setCurrentUser] = useState({});
    const wizardContext = useContext(WizardContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const ModalService = MLModalService();
    const {
        steps, jumpTo, stepsWithErrors, wizardTitle, wizardData, currentStep, currentStepIndex, changeNextSteps, goNext, wizardSnapshot, updateWizardData
    } = wizardContext;
    const [newWizardSteps, setNewWizardSteps] = useState([]);
    const { wizardDataWithSnapshotFlag } = useContext(MLWizardDataSnapshotContext);
    const userRef = useRef();
    userRef.current = currentUser;

    const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
    const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
    const baseWizardState = 'baseQnbWizard';

    // to do producer code update 
    // let flow = StateUtils.dataForState(baseWizardState).flowModel;

    const producerCodeStepWhiteList = ['paContactDetails', 'paGroupAssociations', 'paPreFillData', 'paDriverDetails',
        'paVehicleDetails', 'paAddtlInfoToQuote', 'paDisclosureToQuote', 'startQuote',
        'quoteDetails', 'hoContactDetails', 'hoPrequalQuestions',
        'hoGroupAssociations', 'hoConstruction', 'hoRating', 'hoAddtlInfoToQuote',
        'hoDisclosureToQuote', 'pupContactDetails', 'pupPrequalQuestions', 'pupGroupAssociations',
        'pupUnderlyingPolicies', 'pupVehicleDriverHouseHoldDetails', 'pupWatercraftLocationBusinessDetails',
        'pupDisclosureToQuote','compPaGroupAssociations','compPaPrefillResults','compPaDrivers', 'compPaVehicles', 'compPaValidateInfo', 'compHoGroupAssociations', 'compHoValidateInfo', 'compHoDetails'];

    const MLProducerTypes = {
        'IA': 'ia',
        'PCS': 'pcs',
        'GCS': 'gcs',
        'NationalAccountsCallCenter': 'nationalaccountscallcenter',
        'BrokerCallCenter': 'brokercallcenter',
        'Digital': 'digital'
    };

    // For Policy Change, wizard data is a wrapper around subVM
    let submissionVM = wizardData;
    if (_.has(wizardData, 'submissionVM')) {
        submissionVM = wizardData.submissionVM;
    }

    const [policyNickname, setPolicyNickname] = useState(_.get(submissionVM, 'bindData.policyNickname_ML.value', ''));
    const { customMessageModal, history } = props;
    const jobType = _.get(submissionVM, 'baseData.jobType.value.code');
    const [producerCodeOfRecord, setProducerCodeOfRecord] = useState({});
    const [producerCode, setProducerCode] = useState('');
    const [producerName, setProducerName] = useState('');
    const { getPolicyTypeName } = MLPolicyTypeUtil();

    const indicativeQuotes = _.get(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.indicativeQuote.value', []);
    const [indicativeQuoteExpanded, setIndicativeQuoteExpanded] = useState(false)
    // Cancellation stuff
    const isCancellation = wizardData.isCancellation;
    const [policyPeriod, setPolicyPeriod] = useState();
    const [namedInsured, setNamedInsured] = useState();
    const [policyLabel, setPolicyLabel] = useState();
    let isPolHomeowner = !!_.get(policyPeriod, 'lobs_ML.homeowners');
    let isPolAuto = !!_.get(policyPeriod, 'lobs_ML.personalAuto');
    let isPolPup = !!_.get(policyPeriod, 'lobs_ML.personalUmbrella');
    const productCodeName = _.get(policyPeriod,'productCode.value');

    // Rewrite and Reinstatement
    const isRewrite = wizardData.isRewrite;
    const isReinstatement = wizardData.isReinstatement;
    if(isReinstatement || isRewrite){
        isPolHomeowner =  submissionVM.value.isHomeOwners();
        isPolAuto =  submissionVM.value.isPersonalAuto();
        isPolPup = submissionVM.value.isPersonalUmbrella();
    }

    // ML
    const isPolicyChangeML = jobType === 'PolicyChange' || isCancellation || isReinstatement || isRewrite;
    const isProducerCodeSaving = useRef(false);

    const isSpecialityVehicleAvailablePath = 'lobData.personalAuto.specialtyCrossSell_ML.isCrossSellAvailable.value';
    const isIndicativeVisible = !(wizardData?.isRewrite) && !(wizardData?.isCancellation) && submissionVM?.value?.isPersonalAuto() && ['Draft', 'Quoted'].includes(submissionVM?.baseData?.status_ML?.value ?? '') && _.get(submissionVM, isSpecialityVehicleAvailablePath, false)
    
    //NewProduct
    const isModernProduct = _.get(policyPeriod, 'isModernProduct_Ext', false)
        || _.get(submissionVM, 'isModernProduct_Ext.value', false)
        || _.get(submissionVM, 'baseData.isModernProduct_Ext.value', false)
        || _.get(submissionVM, 'policy.asOfDatePeriod.isModernProduct_Ext.value', false)

    const isModernProductPersonalAuto = !!isModernProduct
        && (!!MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value')) || !!isPolAuto);

    
    //US1020295 - Displaying product code name 
    const producerCodeDisplayName = _.get(policyPeriod, 'productName_Ext')
        || _.get(submissionVM, 'baseData.value.productName_Ext')
        || _.get(submissionVM, 'policy.asOfDatePeriod.productName_Ext.value')
        || submissionVM.value?.policy?.asOfDatePeriod?.productName_Ext

    const getProductCodeDisplayName = () => {
        if (isModernProduct && producerCodeDisplayName) {
            if(isPolicyChangeML){
                return `${producerCodeDisplayName}`;
            }
            return `${producerCodeDisplayName} Quote`;
        }
        else if (!isPolicyChangeML) {
            return getQuoteType(_.get(submissionVM, 'baseData.productCode.value'));
        }
        return "";
    };

    const openRiskAnalysisPopup = () => {
        const componentProps = {
            title: messages.riskAnalysis,
            CustomComponent: MLRatingFactorComponent,
            overrideProps: {
                jobOrPolicyNumber: submissionVM.quoteID.value,
                isQuote: true,
                state: submissionVM.baseData.policyAddress.state.value.code,
                authHeader,
                viewModelService,
                userTypeCode: submissionVM.userType_ML.value.code,
                isModernProduct
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    function getQuoteType() {
        const productCode = _.get(submissionVM, 'baseData.productCode.value');
        const coveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
        let quoteType;
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            quoteType = translator(messages.autoQuote);
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            quoteType = translator(messages.umbrellaQuote);
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            if (MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType)) {
                quoteType = translator(messages.hoTypeHome);
            } else if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(coveragePartType)) {
                quoteType = translator(messages.hoTypeRent);
            } else if (MLProductCodeUtil.isHomeOwnersPartialTypeCondo(coveragePartType)) {
                quoteType = translator(messages.hoTypeCondo);
            } else if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(coveragePartType)) {
                quoteType = translator(messages.hoTypeLandlordCondo);
            } else if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(coveragePartType)) {
                quoteType = translator(messages.hoTypeLandlordHome);
            } else {
                console.error(new Error(`Unsupported coverage part type: ${coveragePartType}`));
            }
        } else {
            console.error(new Error(`Unsupported product code: ${productCode}`));
        }
        return quoteType;
    }

    const getPolicyLabel = () => {
        let policyTypeName;
        const productCode = _.get(submissionVM, 'baseData.productCode.value');
        if (MLProductCodeUtil.isHomeOwners(productCode)) {
            policyTypeName = getPolicyTypeName(_.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code'), translator);
        } else {
            policyTypeName = getPolicyTypeName(productCode, translator);
        }
        return `${policyTypeName} ${translator(messages.typePolicy)}`;
    };

    const getPolicyLabelReinstatement = () => {
        let policyTypeName;
        const productCode = _.get(submissionVM, 'value.productCode');
        if (MLProductCodeUtil.isHomeOwners(productCode)) {
            policyTypeName = getPolicyTypeName(_.get(submissionVM, 'value.policy.lobs_ML.homeowners.coveragePartType_ML'), translator);
        } else {
            policyTypeName = getPolicyTypeName(productCode, translator);
        }
        return `${policyTypeName} ${translator(messages.typePolicy)}`;
    };

    const getPolicyIcon = () => {
        const policyName = getPolicyLabel();
        let className;
        switch (policyName) {
            case 'Home Policy':
                className = 'icon-ml-home-detailed-icon'
                break;
            case 'Auto Policy':
                className = 'icon-icon-car-white'
                break;
            case 'Umbrella Policy':
                className = 'icon-foremost-umbrella-icon'
                break;
            case 'Renters Policy':
                className = 'icon-ml-home-detailed-icon'
                break;
            default:
                break
        }
        return className;
    }

    const onEditEffectiveDateClick = () => {
        const index = _.findIndex(steps, ({path}) => path === '/policychange');
        submissionVM.value.editEffectiveDate = true;
        jumpTo(index);
    }

    function _isBookroll() {
        return _.get(submissionVM, 'bookrollInd_ML.value') ? (_.get(submissionVM, 'bookrollInd_ML.value').code === BOOKROLL_WITH_RATE_CAPPING || _.get(submissionVM, 'bookrollInd_ML.value').code === BOOKROLL_WITHOUT_RATE_CAPPING) : false;
    }

    function _isAlaska7Day() {
        return MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value')) && _.get(submissionVM, 'baseData.policyAddress.state.value') === 'AK' && _.get(submissionVM, 'baseData.termType.value') === '7Days';
    }

    const canNameQuote = (quoteName) => {
        return quoteName !== policyNickname && quoteName.length > 0;
    };

    const nameOrRenameQuote = (() => {
        const vm = {
            quoteName: policyNickname
        };

        const onNameThisQuote = (updatedVm) => {
            _.set(submissionVM, 'bindData.policyNickname_ML.value', updatedVm.quoteName);
            setPolicyNickname(updatedVm.quoteName);
            LoadSaveService.setQuotePolicyNickname(submissionVM.value, authHeader)
            return true;
        };

        if (!_isBookroll() && !_isAlaska7Day()) {
            const componentProps = {
                title: policyNickname ? translator(messages.renameThisQuote) : translator(messages.nameThisQuote),
                actionBtnLabel: translator(messages.save),
                cancelBtnLabel: translator(messages.cancel),
                modalBodyStyles: RenameQuoteModalPopupStyles,
                uiProps: RenameQuoteModalPopup.pageContent,
                onSaveAction: onNameThisQuote,
                getOverrideProps: () => {
                    return {
                        quoteNameErrorSpan: {
                            visible: false
                        }
                    };
                },
                viewModel: vm,
                disableButton: () => !(canNameQuote(vm.quoteName)),
                buttonType: 'primary'
            };
            return modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    });

    function isIAOrPCSOrNACCProducer() {
        return (producerCodeOfRecord.producerType_ML === MLProducerTypes.IA || producerCodeOfRecord.producerType_ML === MLProducerTypes.PCS || producerCodeOfRecord.producerType_ML === MLProducerTypes.NationalAccountsCallCenter);
    }

    const getUser_Ext = useCallback((includeProducerCode = false) => {
        return UserService.getCurrentUser(authHeader, includeProducerCode);
    }, [UserService, authHeader]);

    const filterActiveProducerCodes_Ext = (user) => {
        if (user.producerCodes_ML && user.producerCodes_ML.length) {
            user.producerCodes_ML = user.producerCodes_ML.filter((prodCode) => {
                return prodCode.producerStatus_ML === 'Active';
            });
        }
        setCurrentUser(user);
        return user.producerCodes_ML;
    };

    const getProducerCodes_Ext = useCallback(async () => {
        return getUser_Ext(true).then((user) => {
            return filterActiveProducerCodes_Ext(user);
        });
    }, [getUser_Ext]);

    const initUser_Ext = () => { 
        getUser_Ext().then((user) => {
            filterActiveProducerCodes_Ext(user);
        });
    };

    const isProducerContactDefined = () => {
        return !_.isNil(producerCodeOfRecord.producerContactFirstName_ML) && !_.isNil(producerCodeOfRecord.producerContactLastName_ML);
    };

    const getProducerNameToDisplay = () => {
        if (isProducerContactDefined()) {
            return `${producerCodeOfRecord.producerContactLastName_ML}, ${producerCodeOfRecord.producerContactFirstName_ML}`;
        }
        return producerCodeOfRecord.group_ML.name;
    };

    const getDefaultProducerCode_Ext = () => {
        const availableProducerCodes = userRef.current.producerCodes_ML;
        return availableProducerCodes ? availableProducerCodes.find((code) => {
            return code.code === submissionVM.baseData.producerCode_ML.value
        }) : userRef.current.primaryProducerCode_ML;
    };

    const setProducerInfo_Ext = () => {
        setProducerCodeOfRecord(_.get(submissionVM, 'producerCodeOfRecord_ML.value', getDefaultProducerCode_Ext()));
    };

    const getPolicyIconCancellation = () => {
        if(isPolHomeowner) return "icon-ml-home-detailed-icon";
        if(isPolAuto) return "icon-icon-car-white";
        if(isPolPup) return "icon-foremost-umbrella-icon";
    }

    const getPolicyPeriod = () => {
        const promise = PolicyService.getLatestPolicyPeriodForPolicy(submissionVM.policy.policyNumber.value, authHeader);
        ModalService.showProgressDialog(platformMessages.loading, promise, true);
        promise.then((pol) => {
            setPolicyPeriod(pol);
        });
    }

    if (wizardDataWithSnapshotFlag.current) {
        if (!_.isEqual(wizardData.value, wizardSnapshot.value)) {
            _.set(wizardData, 'value', _.cloneDeep(wizardSnapshot.value));
            updateWizardData(wizardData);
        }

        wizardDataWithSnapshotFlag.current = false;
    }

    useEffect(() => {
        if (!_.isEmpty(producerCodeOfRecord)) {
            setProducerName(getProducerNameToDisplay());
            setProducerCode(producerCodeOfRecord.code)
        }  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [producerCodeOfRecord])

    useEffect(() => {
        if (!_.isEmpty(currentUser)) {
            setProducerInfo_Ext();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])

    // Extract producer code value for proper dependency tracking
    const currentProducerCodeValue = _.get(submissionVM, 'baseData.producerCode_ML.value');

    // Watch for changes in producerCode_ML and update sidebar display
    useEffect(() => {
        if (!currentProducerCodeValue) {
            return;
        }

        const updateProducerCodeInSidebar = async () => {
            try {
                // Always refetch to ensure fresh data when producer code changes
                const producerCodes = await getProducerCodes_Ext();
                
                if (producerCodes && Array.isArray(producerCodes) && producerCodes.length > 0) {
                    const selectedProducerCodeData = producerCodes.find((pc) => pc.code === currentProducerCodeValue);
                    if (selectedProducerCodeData) {
                        setProducerCodeOfRecord(selectedProducerCodeData);
                        setProducerCode(selectedProducerCodeData.code);
                        setProducerName(
                            !_.isNil(selectedProducerCodeData.producerContactFirstName_ML) && !_.isNil(selectedProducerCodeData.producerContactLastName_ML)
                                ? `${selectedProducerCodeData.producerContactLastName_ML}, ${selectedProducerCodeData.producerContactFirstName_ML}`
                                : selectedProducerCodeData.group_ML?.name
                        );
                    }
                }
            } catch (error) {
                console.error('Error updating producer code in sidebar:', error);
            }
        };

        updateProducerCodeInSidebar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentProducerCodeValue, getProducerCodes_Ext])

    useEffect(() => {
        if(isCancellation && !policyPeriod){
            getPolicyPeriod();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isCancellation && policyPeriod){
            if(!namedInsured){
                setNamedInsured(policyPeriod.namedInsureds_ML.find((ins) => ins.isPrimaryNamedInsured_ML));
            }
            if(!policyLabel){
                setPolicyLabel(translator(messages.cancellationTypePolicy, {policyType: getPolicyTypeName(policyPeriod.policyProductCode_ML)}))
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policyPeriod]);

    function displayUpdateProducerCode() {
        return producerCodeStepWhiteList.indexOf(currentStep.mlStepName) >= 0 && isIAOrPCSOrNACCProducer();
    }

    const getProducerCodeDisplayName = (prodCode, flag) => {
        const displayName = (strings, lastName, firstName, code) => {
            const retval = [];
            const comma = strings[1];
            const hyphen = strings[2];

            if (lastName) {
                retval.push(lastName);
            }

            if (firstName) {
                if (lastName) {
                    retval.push(`${comma} `);
                }
                retval.push(firstName);
            }
            if (flag) {
                if (lastName) {
                    retval.push(` ${hyphen} `);
                }
                retval.push(code);
            }

            return retval.join('');
        };
        return displayName`${prodCode.producerContactLastName_ML}, ${prodCode.producerContactFirstName_ML} - ${prodCode.code}`;
    };

    async function updateProducerCode() {
        let producerEligibilityError = false;
        let producerEligibilityErrorMsg = '';

        const handleEligibilityError = (data) => {
            const defaultReason = translator(messages.producerEligibilityError);
            const reasonToShow = !_.isNil(data.nonEligibleReason) ? data.nonEligibleReason : defaultReason;
            producerEligibilityError = true;
            producerEligibilityErrorMsg = reasonToShow;
        };

        if (!_isBookroll() && !_isAlaska7Day()) {
            const formatAvailableValues = (producerCodes) => {
                if (!producerCodes) return [];

                const sortedProducerCodes = _.orderBy(producerCodes, ['producerContactLastName_ML']);
                return sortedProducerCodes.map((code) => {
                    return {
                        code: code.code,
                        name: getProducerCodeDisplayName(code, true)
                    }
                });
            };

            const unFormattedCodes = await getProducerCodes_Ext();
            const formattedCodes = formatAvailableValues(unFormattedCodes);

            const getProducerCodeDisplayNameByCode = (code, flag) => {
                const defaultDisplayName = '-';
                const selectedProducerCode = userRef.current.producerCodes_ML.find((prodCode) => prodCode.code === code);
                if (selectedProducerCode) {
                    return getProducerCodeDisplayName(selectedProducerCode, flag);
                }
                return defaultDisplayName;
            };

            const getProducerCodeOfRecordByProducerCode = (code) => {
                return userRef.current.producerCodes_ML.filter((el) => {
                    return el.code === code;
                })[0];
            };         

            const persistProducerAutoUpdatedFlag = (submission) => {
                const status = _.get(submission, 'baseData.status_ML') || _.get(submission, 'baseData.status_ML.value');
                const isQuoted = status === 'Quoted';

                if (isQuoted) {
                    return LoadSaveService.updateQuotedSubmission(submission, authHeader);
                }

                return LoadSaveService.updateDraftSubmission(submission, authHeader);
            };

            const requestProducerEligibility = (code) => {
                isProducerCodeSaving.current = true;
                producerEligibilityError = false;
                const submission = submissionVM.value;
                const req = {
                    state: submissionVM.baseData.policyAddress.state.value.code,
                    producerCodeCode: code,
                    policyStatus: 'New',
                    skipGroupEligibilityCheck : true
                };

                const producerUpdateFlowPromise = (async () => {
                    const data = await MLProducerEligibilityService.isProducerCodeEligible(req, authHeader);
                    if (!data.isEligible || !_.isNil(data.nonEligibleReason)) {
                        handleEligibilityError(data);
                        return false;
                    }

                    setProducerCode(code);
                    setProducerName(getProducerCodeDisplayNameByCode(code, false));
                    submission.baseData.producerCode_ML = code;
                    submission.baseData.producerAutoUpdated_Ext = false;
                    const codeOfRecord = getProducerCodeOfRecordByProducerCode(code);
                    submission.producerCodeOfRecord_ML = codeOfRecord;

                    if (!_.isUndefined(submissionVM.quoteID.value)) {
                        await LoadSaveService.updateProducerCode(submissionVM.quoteID.value, code, authHeader);
                        await persistProducerAutoUpdatedFlag(submission);

                        if (currentStep.mlStepName === 'quoteDetails') {
                            const selectedQuoteId = submission.bindData.chosenQuote;
                            const selectedQuote = _.find(_.get(submission, 'quoteData.offeredQuotes', []), (quote) => {
                                return quote.publicID === selectedQuoteId;
                            });
                            if (selectedQuote) {
                                if (!selectedQuote.quoteStatus) {
                                    selectedQuote.quoteStatus = {};
                                }
                                selectedQuote.quoteStatus.isStale = true;
                            }
                        }
                    }

                    return true;
                })().catch((error) => {
                    console.error(error);
                    handleEligibilityError(error);
                    return false;
                }).finally(() => {
                    isProducerCodeSaving.current = false;
                });

                ModalService.showProgressDialog('Updating Producer Code...', producerUpdateFlowPromise);
                return producerUpdateFlowPromise;
            };

            const vm = {
                producerCode
            }

            const componentProps = {
                title: translator(messages.updateProducerCode),
                actionBtnLabel: messages.save,
                cancelBtnLabel: messages.cancel,
                uiProps: UpdateProducerCodePopup.pageContent,
                getOverrideProps: () => {
                    return {
                        producerEligiblitityError: {
                            visible: producerEligibilityError,
                            message: producerEligibilityErrorMsg
                        },
                        producerCodeDropdown: {
                            alwaysShowPlaceholder: true,
                            path: 'producerCode',
                            availableValues: formattedCodes
                        }
                    };
                },
                viewModel: vm,
                onAsyncSaveAction: async () => {
                    return requestProducerEligibility(vm.producerCode).then((value) => {
                        return value;
                    });
                },
                disableButton: () => isProducerCodeSaving.current
            };
    
            modalApi.showModal(
                <FormModalPopover {...componentProps} />)
        }
    }

    const viewModelService = useContext(ViewModelServiceContext);

    const openNoteDetailModal = () => { 
        const accountNumber = submissionVM.baseData.accountNumber.value;
        const note = {
            createdDate: new Date(),
            accountNumber: accountNumber,
            topic: 'servicing_ml',
            authorName: userRef.current.displayName
        };

        const noteVM = viewModelService.create(note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');

        const addNote = () => {
            return AccountService.createNoteForAccount(accountNumber, noteVM.value, authHeader)
                .then(() => {
                    MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Note`);
                    return true;
                });
        };

        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Note`);;
        const componentProps = {
            title: NoteDetailsPopupMessages.addNote,
            uiProps: NoteDetailsPopup.componentContent,
            actionBtnLabel: _.upperCase(translator(NoteDetailsPopupMessages.addNote)),
            cancelBtnLabel: NoteDetailsPopupMessages.cancelModal,
            disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
            viewModel: noteVM,
            getOverrideProps: () => {
                return {
                    policyAccountNumber: {
                        label: translator(NoteDetailsPopupMessages.accountNumber),
                        value: accountNumber
                    },
                    category: {
                        value: "Servicing"
                    }
                }
            },
            onAsyncSaveAction: () => {
                return addNote();
            },
            buttonType: 'secondary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );

    };

    const handleError = (error) => {
        console.error('Error updating bundle', error);
    };

    const getSelectedQuoteOffering = () => {
        const subVM = submissionVM.value
        const selectedQuoteIdOffering = subVM?.bindData?.chosenQuote;
        const selectedQuoteOffering = _.find(_.get(subVM, 'quoteData.offeredQuotes', []), (quote) => {
            return quote.publicID === selectedQuoteIdOffering;
        });
        return selectedQuoteOffering;
    }

    const showNewQuoteDialog = (account) => {
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history,
            indicativeUmbInd: true,
            indicativeUmbPremium: getSelectedQuoteOffering().premium.indicativeUmbPremium,
            indicativeAutoJobWithUmb: _.get(submissionVM.value, 'quoteID')
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'outlined',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const addUmbrella = () => {
        const submission = submissionVM.value

        UserService.getCurrentUser(authHeader).then((user) => {
            PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Add Indicative Umbrella'});
        });

        const chosenQuote = getSelectedQuoteOffering();

        if ((_.isUndefined(chosenQuote) && submission?.baseData?.status_ML !== "Quoted") || (!_.isUndefined(chosenQuote) && chosenQuote.status !== "Quoted")
            || (!_.isUndefined(chosenQuote) && chosenQuote.quoteStatus?.isStale)) {
            ModalService.showInfo(messages.requoteTitle, messages.requoteAuto);
        } else {
            MLBundleService.addJobToBundle(submissionVM.value.quoteID, authHeader)
                .then(() => {
                    AccountPolicyService.getAccountDetails(submissionVM.baseData.accountNumber.value, authHeader).then((account) => {
                        // onSave();
                        setTimeout(() => showNewQuoteDialog(account), 100);
                    });
                })
                .catch((error) => {
                    handleError(error);
                });
        }
    }

    useEffect(() => {
        if (!isPolicyChangeML) {
            initUser_Ext();

            if (MLProductCodeUtil.isHomeOwners(_.get(submissionVM, 'baseData.productCode.value'))){
                const coveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
                if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(coveragePartType)) {
                    const constructionIndex = _.findIndex(steps, (step) => step.mlStepName === 'hoConstruction');
                    if (constructionIndex > -1) {
                        steps[constructionIndex].stepHidden = true;
                    }
                }
            }

            // Logic to make binding scripts step visible after visited
            const bindingScriptsIndex = _.findIndex(steps, (step) => step.mlStepName === "bindingScripts");
            if (bindingScriptsIndex > -1 && (currentStep.mlStepName === "bindingScripts" || steps[bindingScriptsIndex].visited === true)) {
                steps[bindingScriptsIndex].stepHidden = false;
            }
        }
        
        steps.forEach((step, index) => {
            if (index < currentStepIndex) {
                step.status = STATUS_COMPLETE;
            } else if (index === currentStepIndex) {
                step.status = STATUS_ACTIVE;
            } else {
                step.status = STATUS_PENDING;
            }
        });

        const visibleSteps = steps.filter((step) => !step.stepHidden);

        let prevIndex = 0;
        const mappedSteps = visibleSteps.reduce((reduced, item) => {
            const groupName = translator(item.groupName);
            if (groupName) {
                if (reduced.length === 0 || groupName !== reduced[prevIndex].group) {
                    reduced.push({
                        group: groupName,
                        steps: [],
                    });
                    prevIndex = reduced.length - 1;
                }

                reduced[prevIndex].steps.push(item)
            } else {
                reduced.push({
                    group: '',
                    step: item
                });
                prevIndex = reduced.length - 1;
            }
            return reduced;
        }, []);

        mappedSteps.forEach((mappedStep) => {
            if (mappedStep.group) {
                mappedStep.isOpen = mappedStep.steps.some((s) => s.status === STATUS_ACTIVE);

                mappedStep.status = STATUS_PENDING;
                if (mappedStep.isOpen) {
                    mappedStep.status = STATUS_ACTIVE;
                } else if (mappedStep.steps[mappedStep.steps.length - 1].status === STATUS_COMPLETE) {
                    mappedStep.status = STATUS_COMPLETE;
                }
            }
        });
        setNewWizardSteps(mappedSteps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToAccountSummary = () => {
        history.push(`/accounts/${submissionVM.baseData.accountNumber.value}/summary`);
    };

    const goToEndorsementAccountSummary = useCallback(async () => {
        const componentProps = {
            title: translator(messages.confirmationTitle),
            actionBtnLabel: translator(messages.yes),
            cancelBtnLabel: translator(messages.cancel),
            simpleMessage: translator(messages.confirmationDesc),
            closeSimpleMessage: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(history.push(`/accounts/${_.get(submissionVM, 'baseData.accountNumber.value')}/summary`));
    }, [history, submissionVM, translator]);

    const goToAccountSummaryCancellation = () => {
        history.push(`/accounts/${policyPeriod.accountNumber_ML}/summary`);
    };

    const withdrawCancellation = () => {
        goToAccountSummaryCancellation();
    };

    const withdrawPolicyChange = useCallback(async () => {
        const withdrawAndGoPoliciesPage = () => {
            MLTagManagerService.sendLinkClickEvent('Discard All Changes');
            const jobID = submissionVM.value.jobID;
            if (jobID) {
                const withdrawPromise = EndorsementService.withdrawEndorsement([jobID], authHeader);
                ModalService.showProgressDialog(messages.withdrawingPolicyChange, withdrawPromise);
            }
            _.set(wizardData, 'submissionVM.value.withdrawPolicyChange', true);
            updateWizardData(wizardData);

            history.push(`/policies/${_.get(submissionVM, 'policyNumber.value')}/summary`);
        };

        const componentProps = {
            title: translator(messages.deleteConfirmationTitle),
            actionBtnLabel: translator(messages.delete),
            cancelBtnLabel: translator(messages.cancel),
            simpleMessage: translator(messages.deleteConfirmationDesc),
            closeSimpleMessage: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(withdrawAndGoPoliciesPage);
    }, [EndorsementService, ModalService, authHeader, history, submissionVM, translator]);

    const getCancellationSidebar = () => {
        return (
            <div>
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={classNames(styles.endorsementAccountIcon)} onClick={goToAccountSummaryCancellation} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToAccountSummaryCancellation}
                                className={styles.accountName}
                            >
                                {_.get(namedInsured, 'displayName')}
                                <Icon icon="mi-arrow-right" />                       
                            </h2>  

                            <div className="display-flex">
                                <a href={`${prodEnvironmentUrl}/policies/${submissionVM.policy.policyNumber.value}/riskAnalysis`} target="_blank" rel="noreferrer" className={styles.viewRiskAnalysisLink}>
                                    {translator(messages.viewRiskAnalysis)}
                                </a>
                            </div>
                        </div>
                    </section>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section clearfix vertical-spacing-15">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <span className={getPolicyIconCancellation()} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={classNames(styles.whiteLink, "header-light")}>{policyLabel}</h2>
                            <span className="header-light">
                                {translator(messages.policyNumber, { policyNumber: _.get(policyPeriod, 'policyNumber') })}
                            </span>
                        </div> 
                    </div>
                    <div className="ml-leftrail-nav__header-section-content">
                        <h2 className={styles.producerCodeNamePolicyChange}>{getProductCodeDisplayName()}</h2>
                    </div> 
                    <div className="ml-leftrail-nav__header-section clearfix">
                        <div className="ml-leftrail-nav__header-section-location-icon">
                            <span className="icon-ml-location" />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <span className="header-light">{_.get(policyPeriod, 'address_ML.displayName')}</span>
                        </div>
                    </div>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section ml-leftrail-effective-date clearfix">
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={styles.whiteLink}>{translator(messages.effectiveDate)}</h2>
                            <DateValue displayFormat='vshort' value={_.get(submissionVM, 'effectiveDate.value')} tag="span" />
                        </div>
                    </section>
                </header>
            </div>
        );
    }

    const getPolicyLabelRewrite = () => {
        let policyTypeName;
        if (submissionVM.value.isHomeOwners()) {
            policyTypeName = getPolicyTypeName(_.get(submissionVM, 'value.policy.latestPeriod.lobs_ML.homeowners.coveragePartType_ML'), translator);
        } else {
            policyTypeName = getPolicyTypeName(_.get(submissionVM, 'value.policy.product.publicID'), translator);
        }
        return `${policyTypeName} ${translator(messages.typePolicy)}`;
    };

    const goToAccountSummaryRewrite = () => {
        history.push(`/accounts/${_.get(submissionVM, 'value.policy.account.accountNumber')}/summary`);

    }

    const withdrawRewrite = () => {
        history.push(`/policies/${_.get(submissionVM, 'value.policy.policyNumber')}/summary`);
    }

    const getRewriteSidebar = () => {
        return (
            <div>
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={classNames(styles.endorsementAccountIcon)} onClick={goToAccountSummaryRewrite} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToAccountSummaryRewrite}
                                className={styles.accountName}
                            >
                                {_.get(submissionVM, 'value.policy.account.accountHolder.displayName')}
                                <Icon icon="mi-arrow-right" />                       
                            </h2>  

                            <div className="display-flex">
                                <a href={`${prodEnvironmentUrl}/policies/${submissionVM.policy.policyNumber.value}/riskAnalysis`} target="_blank" rel="noreferrer" className={styles.viewRiskAnalysisLink}>
                                    {translator(messages.viewRiskAnalysis)}
                                </a>
                            </div>
                        </div>
                    </section>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section clearfix vertical-spacing-15">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <span className={getPolicyIconCancellation()} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={classNames(styles.whiteLink, "header-light")}>{getPolicyLabelRewrite()}</h2>
                            <span className="header-light">
                                {translator(messages.policyNumber, { policyNumber: _.get(submissionVM, 'value.policy.policyNumber') })}
                            </span>
                        </div> 
                    </div>
                    <div className="ml-leftrail-nav__header-section-content">
                        <h2 className={styles.producerCodeNamePolicyChange}>{getProductCodeDisplayName()}</h2>
                    </div> 
                    <div className="ml-leftrail-nav__header-section clearfix">
                        <div className="ml-leftrail-nav__header-section-location-icon">
                            <span className="icon-ml-location" />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <span className="header-light">{_.get(submissionVM, 'value.policy.latestPeriod.address_ML.displayName')}</span>
                        </div>
                    </div>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section ml-leftrail-effective-date clearfix">
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={styles.whiteLink}>{translator(messages.effectiveDate)}</h2>
                            <DateValue displayFormat='vshort' value={_.get(submissionVM, 'effectiveDate.value')} tag="span" />
                        </div>
                    </section>
                </header>
            </div>
        );
    }

    const goToAccountSummaryReinstatement = () => {
        history.push(`/accounts/${_.get(submissionVM,'value.account.accountNumber')}/summary`);
    };

    const withdrawReinstatement = () => {
        history.push(`/policies/${_.get(submissionVM,'value.policyNumber')}/summary`);
    };

    const getReinstatementSidebar = () => {
        return (
            <div>
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={classNames(styles.endorsementAccountIcon)} onClick={goToAccountSummaryReinstatement} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToAccountSummaryReinstatement}
                                className={styles.accountName}
                            > 
                                {_.get(submissionVM, 'value.account.accountHolder.displayName')} 
                                <Icon icon="mi-arrow-right" />                       
                            </h2>  

                            <div className="display-flex">
                                <a href={`${prodEnvironmentUrl}/policies/${submissionVM.value.policyNumber}/riskAnalysis`} target="_blank" rel="noreferrer" className={styles.viewRiskAnalysisLink}>
                                    {translator(messages.viewRiskAnalysis)}
                                </a>
                            </div>
                        </div>
                    </section>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section clearfix vertical-spacing-15">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <span className={getPolicyIconCancellation()} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={classNames(styles.whiteLink, "header-light")}>{getPolicyLabelReinstatement()}</h2>
                            <span className="header-light">
                                {translator(messages.policyNumber, { policyNumber: _.get(submissionVM, 'value.policyNumber') })}
                            </span>
                        </div> 
                    </div>
                    <div className="ml-leftrail-nav__header-section-content">
                        <h2 className={styles.producerCodeNamePolicyChange}>{getProductCodeDisplayName()}</h2>
                    </div> 
                    <div className="ml-leftrail-nav__header-section clearfix">
                        <div className="ml-leftrail-nav__header-section-location-icon">
                            <span className="icon-ml-location" />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <span className="header-light">{_.get(submissionVM, 'value.address_ML.displayName')}</span>
                        </div>
                    </div>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section ml-leftrail-effective-date clearfix">
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={styles.whiteLink}>{translator(messages.effectiveDate)}</h2>
                            <DateValue displayFormat='vshort' value={_.get(submissionVM, 'effectiveDate.value')} tag="span" />
                        </div>
                    </section>
                </header>
            </div>
        );
    }
    
    const getEndorsementSidebar = () => {
        return (
            <div>
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={classNames(styles.endorsementAccountIcon)} onClick={goToEndorsementAccountSummary} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToEndorsementAccountSummary}
                                className={styles.accountName}
                            >
                                {_.get(submissionVM, 'baseData.accountName.value')}    
                                <Icon icon="mi-arrow-right" />                       
                            </h2>  

                            <div className="display-flex">
                                <a href={`${prodEnvironmentUrl}/policies/${submissionVM.policyNumber.value}/riskAnalysis`} target="_blank" rel="noreferrer" className={styles.viewRiskAnalysisLink}>
                                    {translator(messages.viewRiskAnalysis)}
                                </a>
                            </div>
                        </div>
                    </section>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section clearfix vertical-spacing-15">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <span className={getPolicyIcon()} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={classNames(styles.whiteLink, "header-light")}>{getPolicyLabel()}</h2>
                            <span className="header-light">
                                {translator(messages.policyNumber, { policyNumber: _.get(submissionVM, 'policyNumber.value') })}
                            </span>
                        </div> 
                    </div>
                    <div className="ml-leftrail-nav__header-section-content">
                        <h2 className={styles.producerCodeNamePolicyChange}>{getProductCodeDisplayName()}</h2>
                    </div> 
                    <div className="ml-leftrail-nav__header-section clearfix">
                        <div className="ml-leftrail-nav__header-section-location-icon">
                            <span className="icon-ml-location" />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                        {
                            <span className="header-light">{_.get(submissionVM, 'baseData.productCode.value') === "PersonalAuto"?_.get(submissionVM, 'baseData.physicalLocationAddress_ML.displayName.value'):_.get(submissionVM, 'baseData.policyAddress.displayName.value')}</span> 
                        }
                        </div>
                    </div>
                </header>

                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section ml-leftrail-effective-date clearfix">
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={styles.whiteLink}>{translator(messages.effectiveDate)}</h2>
                            <DateValue displayFormat='vshort' value={_.get(submissionVM, 'baseData.effectiveDate.value')} tag="span" />
                            {currentStep.mlStepName !== 'endorsementConfirmation' && <div>
                                <a className="padding-top-5 display-inline-block" onClick={onEditEffectiveDateClick}>
                                    {translator(messages.editEffectiveDate)}
                                </a>
                            </div>}
                        </div>
                    </section>
                </header>
                <div role="navigation" aria-label={translator(wizardTitle)}>
                    <ul className={classNames(styles.endorsementLeftRailUl, "ml-leftrail-nav__menu")}>
                        <li className="ml-leftrail-nav__menu-item expanded">
                            <MLNavigationStepsComponent currentStep={currentStep} changeNextSteps={changeNextSteps} goNext={goNext} endorsementVM={submissionVM} steps={steps} />
                        </li>
                    </ul>
                </div>
                {currentStep.mlStepName !== 'endorsementConfirmation' && <div className="ml-leftrail-nav__btn-container">
                    <Button type="outlined" onClick={withdrawPolicyChange}>
                        {translator(messages.discardAllChanges)}
                    </Button>
                </div>
                }
            </div>
        );
    }

    const openInNewTab = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
        window.focus();
    }

    const getSpecialityIndicativeQuotes = useCallback(() => {
        const indicativeQuoteConfig = {
           "MC": {
                vehicleType: "Motorcycle",
                icon: motorcycle,
                prefix: "a"
           },
           "com.foremost_Off-RoadMotorcycle": {
                vehicleType: "Off-Road Motorcycle",
                icon: atv,
                prefix: "an"
           },
           "ATV": {
                vehicleType: "ATV",
                icon: atv,
                prefix: "an"
           },
           "DB": {
                vehicleType: "Dune Buggy",
                icon: atv,
                prefix: "a"
           },
           "GC": {
                vehicleType: "Golf Cart",
                icon: golfcart,
                prefix: "a"
           },
           "SNOWM": {
                vehicleType: "Snowmobile",
                icon: snowmobile,
                prefix: "a"
           },
           "LSV": {
                vehicleType: "Low Speed Vehicle",
                icon: golfcart,
                prefix: "a"
           },
           "MH": {
                vehicleType: "Motor Home",
                icon: motorhome,
                prefix: "a"
           },
           "TR": {
                vehicleType: "Travel Trailer/Utility Trailer",
                icon: traveltrailer,
                prefix: "a"
           },
           "BOAT": {
                vehicleType: "Boat Watercraft",
                icon: boat,
                prefix: "a"
           },
           "8": {
                vehicleType: "Personal Watercraft",
                icon: boat,
                prefix: "a"
           },
           "P": {
                vehicleType: "Pontoon",
                icon: boat,
                prefix: "a"
           },
           "MS": {
                vehicleType: "Scooter/Moped",
                icon: motorcycle,
                prefix: "a"
           }
        }
        const filteredQuote = indicativeQuoteExpanded ? indicativeQuotes : indicativeQuotes.slice(0,1)
        if(!filteredQuote || filteredQuote.length === 0) {
            return <></>;
        }
        const constructedIndicativeQuote =  filteredQuote.map(quote => {
             return (
                    <div className="ml-leftrail-nav__header-section vertical-spacing-10 clearfix">
                        <div className={styles.indicativeUmbQuoteContainer}>
                            <div className={styles["container-fluid"]}>
                                <div>
                                    <div className={classNames(styles.indicativeUmbQuote, "row display-flex", "vertical-spacing-10")}>
                                        <div className="col-xs-12 vertical-spacing-10">
                                            <div className={styles.indicativeUmbQuoteHeader}>{translator(messages.needIndicativeQuote, { quoteName: indicativeQuoteConfig[quote?.crossSellProductType]?.vehicleType, quotePrefix: indicativeQuoteConfig[quote?.crossSellProductType]?.prefix })}  <Image src={indicativeQuoteConfig[quote?.crossSellProductType]?.icon} alt="" /></div>
                                            <div className={styles.indicativeUmbQuoteSubHeader}>
                                                {(quote?.status === "Failed" || _.isNil(quote?.estimatedPremium)) ? 
                                                    ( <div className={styles.indicativeQuoteError}>{translator(messages.indicativeResponseError)}</div>) : 
                                                    (<>
                                                    <div>{translator(messages.estimatedPremium)}</div>
                                                    <div className={styles.indicativeUmbQuoteSubHeaderPrice}>${quote?.estimatedPremium}{'/yr'}</div>
                                                    </>)
                                                }
                                                
                                            </div>
                                            {!_.isNil(quote?.estimatedPremium) && !_.isNil(quote?.foremostQuoteUrl) && (<div className={styles.indicativeUmbQuoteLinkContainer}><Button type="outlined" onClick={()=>openInNewTab(quote?.foremostQuoteUrl)}>{translator(messages.goToSpeciality)}</Button></div>)}
                                            <div className={classNames("header-light", styles.indicativeUmbQuoteDisclaimer)}>{translator(messages.estimatedPremiumMessage)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            )
        })
    
        return (
                <header className="ml-leftrail-nav__header clearfix">
                    {constructedIndicativeQuote}
                    {indicativeQuotes && indicativeQuotes?.length > 1 && <Button type="outlined" icon={indicativeQuoteExpanded ? 'mi-arrow-upward' : 'mi-arrow-downward'} onClick={()=>setIndicativeQuoteExpanded(!indicativeQuoteExpanded)}>{indicativeQuoteExpanded ? "Show less" : "Show more"}</Button>}
                </header>
        )
    }, [indicativeQuoteExpanded, indicativeQuotes])

    const isRiskAnalysisLink = useMemo(() => {
        return _.get(submissionVM, 'baseData.isPFMReturned_ML.value', false);
    }, [submissionVM]);

    const hasIndicativeUmbPremium = () => {
         const chosenQuoteTab = getSelectedQuoteOffering();
         if (chosenQuoteTab) {
             if (!chosenQuoteTab.hasUmbrellaOnAccount_Ext) {
                 const umbInd = chosenQuoteTab.indicativeUmbQuoteIndicator_Ext
                 if (umbInd) {
                     const umbPrem = chosenQuoteTab.premium.indicativeUmbPremium?.amount
                     if (umbPrem) {
                         return umbPrem > 0
                     }
                 }
             }
         }
         return false
    };

    const getSubmissionSidebar = () => {
        return (
            <div>
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix user-icon-section clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={styles.accountIcon} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToAccountSummary}
                                className={styles.accountName}
                            >
                                {_.get(submissionVM, 'baseData.accountHolder.displayFullName_Ext.value')}    
                                <Icon icon="mi-arrow-right" />                       
                            </h2>  

                            {(isRiskAnalysisLink) ?
                                <div className="display-flex">
                                    <a className="white-link" onClick={openRiskAnalysisPopup}>
                                        {translator(messages.riskAnalysis)}
                                    </a>
                                </div>
                                : undefined}
                        </div>
                    </section>
                </header>
                {_.get(submissionVM, 'isBundle_ML.value') &&
                <header className="ml-leftrail-nav__header clearfix">
                    <MlBundleWidget accountNumber={submissionVM.baseData.accountNumber.value}/>
                </header>}
                {isOnQuoteDetailsStep(currentStep) && (_.get(submissionVM, 'baseData.productCode.value') === "PersonalAuto") && hasIndicativeUmbPremium() &&
                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section vertical-spacing-10 clearfix">
                        <div className={styles.indicativeUmbQuoteContainer}>
                            <div className={styles["container-fluid"]}>
                                <div>
                                    <div className={classNames(styles.indicativeUmbQuote, "row display-flex", "vertical-spacing-10")}>
                                        <div className="col-xs-12 vertical-spacing-10">
                                            <div className={styles.indicativeUmbQuoteHeader}>{translator(messages.needUmbrella)} <span className={getLobIconClassName('PersonalUmbrella')}></span></div>
                                            <div className={styles.indicativeUmbQuoteSubHeader}>
                                                <div>{translator(messages.estimatedPremium)}</div>
                                                <div className={styles.indicativeUmbQuoteSubHeaderPrice}>{MLBundleService.formatPremium(getSelectedQuoteOffering().premium.indicativeUmbPremium, intl)}{'/yr'}</div>
                                            </div>
                                            <div className={styles.indicativeUmbQuoteLinkContainer}><a onClick={addUmbrella}>{translator(messages.addUmbrella)}</a></div>
                                            <div className={classNames("header-light", styles.indicativeUmbQuoteDisclaimer)}>{translator(messages.estimatedPremiumMessage)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>}
                {isOnQuoteDetailsStep(currentStep) && isIndicativeVisible && indicativeQuotes.length > 0 && getSpecialityIndicativeQuotes()}
                <header className="ml-leftrail-nav__header clearfix">
                    <div className="ml-leftrail-nav__header-section clearfix vertical-spacing-10">
                        <div className="ml-leftrail-nav__header-section-icon vertical-spacing-10">
                            <span className={getLobIconClassName(_.get(submissionVM, 'baseData.productCode.value'))} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 className={styles.producerCodeName}>{getProductCodeDisplayName()}</h2>
                            <div>
                                {_.get(submissionVM.value, 'quoteID') &&
                                    <span className="padding-right-5">{'#'}{_.get(submissionVM.value, 'quoteID')}</span>}
                                <span className="display-inline-block"><a onClick={openNoteDetailModal}>{translator(messages.addNote)}</a></span>
                            </div>
                            {isOnQuoteDetailsStep(currentStep) &&
                                <div className="policy-nickname-section">
                                    <div>{policyNickname}</div>
                                    {(!policyNickname && !isModernProduct) && (<div className="display-inline-block"><Link className="white-link" onClick={nameOrRenameQuote}>{translator(messages.nameQuote)}</Link></div>)}
                                    {policyNickname && (<div className="display-inline-block"><Link className="white-link" onClick={nameOrRenameQuote}>{translator(messages.rename)}</Link></div>)}
                                </div>}
                        </div>
                    </div>
                </header>
                <header className="ml-leftrail-nav__header clearfix">
                    {displayUpdateProducerCode() && (
                        <section className="ml-leftrail-nav__header-section ml-producer-code-section">
                            <div className="white-link ml-leftrail-nav__header-section-content">
                                <h2 className={styles.whiteLink}>
                                    {translator(messages.producerCode)}
                                </h2>
                                <p className={classNames(styles.producerCode, "padding-bottom-5")}>
                                    {producerCode}
                                    <br />
                                    {producerName}
                                </p>
                                <h2 className="vertical-spacing-10 display-inline-block">
                                    <a ml-note-detail onClick={updateProducerCode}>{translator(messages.updateProducerCode)}</a>
                                </h2>
                            </div>
                        </section>
                    )}          
                </header>
            </div>
        );
    }

    const getSidebar = () => {
        if(isPolicyChangeML){
            if(isCancellation){
                return getCancellationSidebar()
            }
            if(isRewrite){
                return getRewriteSidebar()
            }
            if(isReinstatement){
                return getReinstatementSidebar()
            }
            return getEndorsementSidebar()
        }
        return getSubmissionSidebar()
    }

    const getNavClassname = () => {
        if(isPolicyChangeML && (isCancellation || isReinstatement || isRewrite)){
            return 'ml-leftrail-nav__expanded-menu policy-change'
        }
        return 'ml-leftrail-nav__menu'
    }

    return (
        <div className="ml-leftrail-nav">
            {getSidebar()}
            <div role="navigation" aria-label={translator(wizardTitle)}>
                <ul className={getNavClassname()}>
                    {!(isPolicyChangeML && !isCancellation && !isReinstatement && !isRewrite) && renderSteps(
                        translator,
                        steps,
                        stepsWithErrors,
                        jumpTo,
                        wizardContext,
                        customMessageModal,
                        isPolicyChangeML,
                        newWizardSteps,
                        currentStep,
                        isCancellation || isReinstatement || isRewrite,
                        submissionVM.value,
                        currentStepIndex,
                        wizardDataWithSnapshotFlag
                    )}
                </ul>
            </div>
            
            {isCancellation && currentStep.mlStepName !== 'cancellationConfirmation' && 
                <div className="ml-leftrail-nav__btn-container">
                    <Button type="outlined" onClick={withdrawCancellation}>
                        {translator(messages.discardAllChanges)}
                    </Button>
                </div>
            }
            
            {isRewrite && currentStep.mlStepName !== 'rewriteConfirmation' && 
                <div className="ml-leftrail-nav__btn-container">
                    <Button type="outlined" onClick={withdrawRewrite}>
                        {translator(messages.discardAllChanges)}
                    </Button>
                </div>
            }

            {isReinstatement && currentStep.mlStepName !== 'reinstatementConfirmation' && 
                <div className="ml-leftrail-nav__btn-container">
                    <Button type="outlined" onClick={withdrawReinstatement}>
                        {translator(messages.discardAllChanges)}
                    </Button>
                </div>
            }
        </div>
    );
}

WizardSidebar.propTypes = {
    customMessageModal: PropTypes.shape({})
};
WizardSidebar.defaultProps = {
    customMessageModal: {}
};
export default withRouter(WizardSidebar);
